import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

const initialState={
    colorList:[],
    textilesColor:[],
    selectedColor: null,
    status:"idle",
    textilesStatus:"idle",
    registerstatus:'failure',
    editstatus:'failure',
    deletestatus:'failure',
    error:''
}

export const fetchColors=createAsyncThunk('colors/fetchColors', async ()=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/spage/colors/getColors',
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchColorsByTextiles =createAsyncThunk('colors/fetchColorsByTextiles', async (textiles)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/spage/colors/getColorByTextiles/${textiles}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const fetchColorById=createAsyncThunk('colors/fetchColorById', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/spage/colors/getColorById/${id}`,
        {
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const createColor=createAsyncThunk('colors/createColor', async (color)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/spage/colors/createColor',
        {
            method:'POST',
            body: JSON.stringify(color),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json'
            }
        }
    )
    return response.json()
})

export const updateColor=createAsyncThunk('colors/updateColor', async (color)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        '/baskets/spage/colors/updateColor',
        {
            method:'POST',
            body: JSON.stringify(color),
            headers: {
                'Authorization': `Basic ${auth}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

export const deleteColor=createAsyncThunk('colors/deleteColor', async (id)=>{
    const username = 'admin'
    const password = 'survive9'
    const auth = btoa(`${username}:${password}`)
    const response = await fetch(
        `/baskets/spage/colors/deleteColor/${id}`,
        {
            method:'GET',
            headers: {
                'Authorization': `Basic ${auth}`,
                'Accept': 'application/json'
            }
        }
    )
    return response.json()
})

const colorslice = createSlice({
    name:"colors",
    initialState,
    reducers:{
        changeRegisterStatus:(state)=>{
            state.registerstatus='failure';
        },
        changeEditStatus:(state)=>{
            state.editstatus='failure';
        },
        changeDeleteStatus:(state)=>{
            state.deletestatus='failure';
        }
    },
    extraReducers(builder){
        builder.addCase(fetchColors.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchColors.fulfilled, (state, action) => {
            state.status = 'success';
            state.colorList = action.payload;
        });
        builder.addCase(fetchColors.rejected, (state, action) => {
            state.status = 'error';
            state.error = state.error.message || 'Failed to fetch colors';
        });
        builder.addCase(fetchColorById.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchColorById.fulfilled, (state, action) => {
            state.status = 'success';
            state.selectedColor = action.payload;
        });
        builder.addCase(fetchColorById.rejected, (state, action) => {
            state.status = 'error';
            state.error = state.error.message || 'Failed to fetch color by ID';
        });
        builder.addCase(createColor.pending, (state, action) => {
            state.registerstatus = 'loading';
        });
        builder.addCase(createColor.fulfilled, (state, action) => {
            state.registerstatus = 'success';
            state.colorList.push(action.payload);
        });
        builder.addCase(createColor.rejected, (state, action) => {
            state.registerstatus = 'error';
            state.error = state.error.message || 'Failed to create color';
        });
        builder.addCase(updateColor.pending, (state, action) => {
            state.editstatus = 'loading';
        });
        builder.addCase(updateColor.fulfilled, (state, action) => {
            state.editstatus = 'success';
            const index = state.colorList.findIndex(color => color.id === action.payload.id);
            if (index !== -1) {
                state.colorList[index] = action.payload;
            }
        });
        builder.addCase(updateColor.rejected, (state, action) => {
            state.editstatus = 'error';
            state.error = state.error.message || 'Failed to update color';
        });
        builder.addCase(deleteColor.pending, (state, action) => {
            state.deletestatus = 'loading';
        });
        builder.addCase(deleteColor.fulfilled, (state, action) => {
            state.deletestatus = 'success';
            state.colorList = state.colorList.filter(color => color.id !== action.payload.id);
        });
        builder.addCase(deleteColor.rejected, (state, action) => {
            state.deletestatus = 'error';
            state.error = state.error.message || 'Failed to delete color';
        });
            builder.addCase(fetchColorsByTextiles.pending, (state, action) => {
                state.textilesStatus = 'loading';
            });
            builder.addCase(fetchColorsByTextiles.fulfilled, (state, action) => {
                state.textilesStatus = 'success';
                state.textilesColor = action.payload;
            });
            builder.addCase(fetchColorsByTextiles.rejected, (state, action) => {
                state.textilesStatus = 'error';
                state.error = state.error.message || 'Failed to fetch colors by textiles';
            });
    }
})

export default colorslice.reducer;